export default __webpack_public_path__ + "static/media/TYPH.cf4b65eb.png";